import { render, staticRenderFns } from "./CharitiesTable.vue?vue&type=template&id=0121f1c8&scoped=true"
import script from "./CharitiesTable.vue?vue&type=script&lang=js"
export * from "./CharitiesTable.vue?vue&type=script&lang=js"
import style0 from "./CharitiesTable.vue?vue&type=style&index=0&id=0121f1c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0121f1c8",
  null
  
)

export default component.exports